import { useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
	usePolicies,
	PolicyToggle,
	PolicyViewerHeader,
	DocumentViewer,
	Policy,
} from '@practium/features/policy';
import { PoliciesLayout } from '../layouts/PoliciesLayout';
import styles from './PolicyViewPage.module.css';
import { BasePrimaryButton } from '@practium/ui';

export const PoliciesViewPage = () => {
	const navigate = useNavigate();
	const { id: policyId } = useParams<{ id: string }>();
	const {
		filteredPolicies,
		selectedPolicy,
		isLoading,
		updatingPolicyId,
		handleSearch,
		handleTogglePolicy,
		selectPolicy,
	} = usePolicies();


	useEffect(() => {
		if (policyId && filteredPolicies.length > 0) {
			const policy = filteredPolicies.find((p) => p._id === policyId);
			if (policy) {
				selectPolicy(policy);
			}
		} else if (!policyId && filteredPolicies.length > 0) {
			const firstPolicy = filteredPolicies[0];
			selectPolicy(firstPolicy);
			navigate(`/politicas/${firstPolicy._id}`, { replace: true });
		}
	}, [policyId, filteredPolicies, selectPolicy, navigate]);

	const handleEditClick = useCallback(() => {
		if (selectedPolicy?._id) {
			navigate(`/politicas/editar/${selectedPolicy._id}`);
		}
	}, [selectedPolicy, navigate]);

	const handleAddPolicy = useCallback(() => {
		navigate('/politicas/nova');
	}, [navigate]);

	const handleSelectPolicy = useCallback(
		(policy: Policy) => {
			selectPolicy(policy);
			navigate(`/politicas/${policy._id}`);
		},
		[selectPolicy, navigate]
	);

	const headerContent = (
		<PolicyViewerHeader mode="view">
			<PolicyToggle checked={selectedPolicy?.isActive || false} disabled />
			<BasePrimaryButton onClick={handleEditClick} className={styles.editButton}>
				Editar
			</BasePrimaryButton>
		</PolicyViewerHeader>
	);

	return (
		<PoliciesLayout
			policies={filteredPolicies}
			selectedPolicy={selectedPolicy}
			isLoading={isLoading}
			updatingPolicyId={updatingPolicyId}
			onSearch={handleSearch}
			onTogglePolicy={handleTogglePolicy}
			onSelectPolicy={handleSelectPolicy}
			onAddPolicy={handleAddPolicy}
			headerContent={headerContent}
		>
			<DocumentViewer policy={selectedPolicy} />
		</PoliciesLayout>
	);
};
